<app-panel-body>
  <div
    class="flex min-h-0 flex-1 flex-col"
    *transloco="let t; prefix: 'trip-finances.fundraising-profile-panel'"
  >
    <div class="min-h-0 flex-1 overflow-y-auto">
      <app-content-container>
        @if (context(); as panelContext) {
          <div class="space-y-4" data-testid="fundraising-profile-content">
            <div class="font-medium text-lg">{{ panelContext.profile.name }}</div>

            @if (photoUrl()) {
              <img
                [src]="photoUrl()"
                [alt]="panelContext.profile.name"
                class="h-32 w-32 rounded-full object-cover"
                data-testid="fundraising-profile-photo"
              />
            }

            @if (description()) {
              <p class="text-sm text-primary-text-light whitespace-pre-wrap" data-testid="fundraising-profile-description">
                {{ description() }}
              </p>
            }
          </div>
        }
      </app-content-container>
    </div>

    @if (showActions()) {
      <div
        class="flex shrink-0 gap-3 border-t border-primary-border px-4 py-3"
        data-testid="fundraising-profile-actions"
      >
        <app-button
          variant="danger"
          [fullWidth]="true"
          [disabled]="submitting()"
          (clicked)="reject()"
          data-testid="fundraising-profile-reject"
        >
          {{ t('reject') }}
        </app-button>
        <app-button
          variant="primary"
          [fullWidth]="true"
          [disabled]="submitting()"
          (clicked)="approve()"
          data-testid="fundraising-profile-approve"
        >
          {{ t('approve') }}
        </app-button>
      </div>
    }
  </div>
</app-panel-body>
